import { client } from "./client";
import interceptors from "./interceptors";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function scanLinkSerial(params) {
	return client.get("api/scan-serial/scan", {
		params: params,
	});
}

export default {
	scanLinkSerial,
};